import _ from "lodash";
import React from "react";
import classes from "./LearningGoalsRating.scss";
import { ToggleSwitch, Tooltip } from "@toddle-edu/ds-web";
import { updateAssessment } from "Assessments/modules/AssessmentModule";
import { connect } from "react-redux";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import {
  checkAssessmentHasPypEvaluation,
  checkHasTaggedLearningGoals,
} from "Assessments/modules/Utils";

const styles = {
  containerStyle: {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
  },
  labelContainerStyle: {
    width: "fit-content",
    marginBottom: "0px",
  },
};

class LearningGoalsRating extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isEvaluationEnabled: false,
    };
  }

  componentDidMount = () => {
    const { isLearningGoalsEvaluationEnabled } = this.props;
    this.setState({ isEvaluationEnabled: isLearningGoalsEvaluationEnabled });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { leHasPypEvaluation, updateAssessment, mode } = this.props;
    const { isEvaluationEnabled } = this.state;

    if (
      leHasPypEvaluation !== prevProps.leHasPypEvaluation ||
      isEvaluationEnabled !== prevState.isEvaluationEnabled
    ) {
      // reset isLearningGoalsEvaluationEnabled if user enabled rating switch
      // then dis-select all the learning goals
      const resetLearningGoalsEvalBool = async () => {
        if (!leHasPypEvaluation && isEvaluationEnabled) {
          this.setState({ isEvaluationEnabled: false });
          await updateAssessment({
            isLearningGoalsEvaluationEnabled: false,
            hasFields: false,
          });
        }
      };

      if (mode !== "view") resetLearningGoalsEvalBool();
    }
  };

  onToggleSwitch = async e => {
    const isChecked = _.get(e, "target.checked", false);

    this.setState({ isEvaluationEnabled: isChecked });

    await this.props.updateAssessment({
      isLearningGoalsEvaluationEnabled: isChecked,
      hasFields: false,
    });
  };

  // for "enableRating" field, value will always be null as this component is just to show label and toggle switch
  shouldShowEmpty = () => false;

  renderView = () => {
    const { isLearningGoalsEvaluationEnabled } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.rightContainer}>
          <ToggleSwitch
            checked={isLearningGoalsEvaluationEnabled}
            disabled={true}
            size="medium"
            _legacy_size="xx-small"
          />
        </div>
      </div>
    );
  };

  renderEdit = () => {
    const { t, leHasPypEvaluation, hasTaggedLearningGoals } = this.props;
    const { isEvaluationEnabled } = this.state;

    const disabledTooltip = !leHasPypEvaluation
      ? t(
          hasTaggedLearningGoals
            ? "classRoom:rate_on_learning_goals_vertical_rollup_msg"
            : "classRoom:rate_on_learning_goals_disabled_msg"
        )
      : null;

    return (
      <div className={classes.container}>
        <ConditionalWrapper
          type={"wrapperAsElement"}
          condition={!leHasPypEvaluation}
          wrapper={<Tooltip placement="top" tooltip={disabledTooltip} />}
        >
          <div className={classes.rightContainer}>
            <ToggleSwitch
              checked={isEvaluationEnabled}
              onChange={this.onToggleSwitch}
              disabled={!leHasPypEvaluation}
              size="medium"
              testId={"assignmentCreation-learningGoalsRatingToggle"}
            />
          </div>
        </ConditionalWrapper>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const { assessmentFields = [], assessmentTools = [] } = ownProps;
  const { type: curriculumProgramType = "" } = _.get(
    state,
    "platform.currentCurriculumProgram",
    {}
  );

  // true if at least one learning goal type is tagged AND all tagged types are ratable
  const leHasPypEvaluation = checkAssessmentHasPypEvaluation({
    assessmentFields,
    curriculumProgramType,
    assessmentTools,
  });

  // true if any learning goal is tagged (regardless of grading type)
  const hasTaggedLearningGoals = checkHasTaggedLearningGoals({
    assessmentFields,
    curriculumProgramType,
  });

  return {
    leHasPypEvaluation,
    hasTaggedLearningGoals,
    containerStyle: styles.containerStyle,
    labelContainerStyle: styles.labelContainerStyle,
  };
};

const mapActionCreators = {
  updateAssessment,
};

export default compose(
  I18nHOC({ resource: ["common", "classRoom"] }),
  connect(mapStateToProps, mapActionCreators)
)(LearningGoalsRating);
